import { useQuery } from "@tanstack/react-query";
const { default: apiClient } = require("lib/api-client");

const fetchDesigns = async ({ queryKey }) => {
  const [, { setID, sortBy, sortOrder,searchTerm,isHidden }] = queryKey;
  const response = await apiClient.post("/api/v1/set/getSetById", {
    setId: setID,
    sortBy,
    sortOrder,
    searchTerm,
    isHidden
  });

  if (response.status !== 200) {
    throw new Error("Error fetching categories");
  }

  return response.data;
};

export const useGetDesigns = ({ setID = "", sortBy = "Design Date", sortOrder = "asc", searchTerm ="" , isHidden = true}) => {
  return useQuery({
    queryKey: ["get-designs", { setID, sortBy, sortOrder, searchTerm , isHidden}],
    queryFn: () => fetchDesigns({ queryKey: ["get-designs", { setID, sortBy, sortOrder,searchTerm , isHidden}] }),
    enabled: !!setID, // Only run the query if cardId is present
    // staleTime: 120000,
    select: (data) => ({
      setNumber: data.set.setNumber,
      designs: data.set.designs,
    }),
  });
};
